import moment from "moment";
import React, { useEffect, useState } from "react";
import { Rating } from "semantic-ui-react";
import RangeSlider from "react-range-slider-input";
import {
  addMacros,
  getMacrosData,
} from "../../services/firebase/firestore/saveData";
import Button from "../_default/Button";
import DropDown from "../_default/DropDown";
// import DropDown from '../_default/Header';
import Input from "../_default/Input";
import Loading from "../_default/Loading";

import { IoMdAddCircle } from "react-icons/io";
import { AiFillMinusCircle } from "react-icons/ai";
import { FaMinusCircle } from "react-icons/fa";
import "./TDDECalculator.scss";
import { Pie } from "react-chartjs-2";
import { useRef } from "react";
import Select from "react-select";
import { BsInfoLg } from "react-icons/bs";
// hight light cal
import aurumLogo from "../../assets/images/aurum.png"

const ToolTipComponent = ({ description, direction, className }) => {
  const getDirection = () => {
    const appendedClass = className ? className : "";
    switch (direction) {
      case "top":
      case "right":
      case "left":
        return `${direction} ${appendedClass}`;
      default:
        return `right ${appendedClass}`;
    }
  };
  return (
    <div className={`tooltip-wrapper ${getDirection()}`}>
      {/* <img
             src="https://img.icons8.com/color/50/000000/info.png"
             className="icon"
            /> */}
      <BsInfoLg />
      <div className="description">{description}</div>
    </div>
  );
};

export default function TestCalc({ selectedClient, id }) {
//   console.log('tdde selected client',selectedClient)
  const [activityFactorsText, setActivityFactorsText] = useState([
    "Sedentary",
    "Lightly Active",
    "Moderately Active",
    "Very Active",
    "Extra Active or Athletes",
  ]);

  // const [goal, setGoal] = useState([
  //   `Agressive deficit (-750kcal)`,
  //   "Normal deficit (-500kcal)",
  //   "Small deficit (-350kcal)",
  //   "Maintenance calories",
  //   "Small surplus (+150)",
  //   "Normal surplus (+250)",
  //   "Agressive surplus (+500)",
  // ]);
  const customGoalToolTip = [
    {
      value: "-750",
      label: (
        <>
          <span>Agressive deficit (-750kcal)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              Agressive deficit (Recommended only for people with high bodyfat
              levels)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "-500",
      label: (
        <>
          <span>Normal deficit (-500kcal)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              {" "}
              Normal deficit (Recommended for people with moderate bodyfat
              levels)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "-350",
      label: (
        <>
          <span>Small deficit (-350kcal)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              {" "}
              Small deficit (Recommended for people with lower bodyfat levels)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "0",
      label: (
        <>
          <span>Maintenance calories</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              Maintenance calories (Recommended if people are not looking to
              lose weight)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "+150",
      label: (
        <>
          <span> Small surplus (+150)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              {" "}
              Small surplus (Recommended for people that want to optimally gain
              muscle mass)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "+250",
      label: (
        <>
          <span>Normal surplus (+250)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              Normal surplus (Recommended for people that want to gain muscle
              mass)
            </span>
          </span>
        </>
      ),
    },
    {
      value: "+500",
      label: (
        <>
          <span>Agressive surplus (+500)</span>
          <span className="hover-text">
            <span className="hover-text">
              <BsInfoLg />
            </span>
            <span className="tooltip-text" id="right">
              Agressive surplus (Recommended for people that need to gain weight
              quickly, which will consist of an increase in fat mass too)
            </span>
          </span>
        </>
      ),
    },
  ];
  const [selectedGoal, setSelectedGoal] = useState("-750");
  const [goalValue, setGoalValue] = useState("");
  const [calorieTarget, setCalorieTarget] = useState("");
  const [loading, setLoading] = useState(true);
  const [genderDrop, setGenderDrop] = useState(["Male", "Female"]);
  const [error, setError] = useState(false);
  const [choosedFactor, setChoosedFactor] = useState("Select activity");
  const [choosedGoal, setChoosedGoal] = useState("Select Goal");
  let [calInfoSlider, setCaloInfoSlider] = useState(0);
  const [chooseGender, setChooseGender] = useState("");
  let [proteinSlider, setProtienSlider] = useState(0.0);
  let [fat, setFat] = useState("00");
  let [fatSlider, setFatSlider] = useState(0.0);
  const [calFat, setCalFat] = useState(0);
  const [calProtein, setCalProtein] = useState(0);
  const [calFiber, setCalFiber] = useState(0);
  const [calCarbohydrates, setCalCarbohydrates] = useState(0);
  const [calAlcohol, setCalAlcohol] = useState(0);
  const [showCalculator, setShowCalculator] = useState(true);
  let [protienPerDay, setProtienPerDay] = useState(0);
  let [fatTDEE, setFatTDEE] = useState(0);
  let [carbohaydratePercentCal, setCarboHyderatePercentCal] = useState(0);
  let [carbohaydratePerDay, setCarboHyderatePerDay] = useState(0);
  let [leanBodyMass, setLeanBodyMass] = useState(0);
  let [proteinLeanMass, setProteinLeanMass] = useState(0.0);
  let [proteinCaloriesPerDay, setProteinCaloriesPerDay] = useState(0);
  let [fatCalories, setFatCalories] = useState(0.0);
  let [weight, setWeight] = useState("");
  let [height, setHeight] = useState("");
  let [age, setAge] = useState("");
  let [client_id, set_client_id] = useState("");

  const [totalCalories, setTotalCalories] = useState(calInfoSlider);
  const [totalProtein, setTotalProtein] = useState(proteinCaloriesPerDay);
  const [totalFat, setTotalFat] = useState(fatCalories);
  const [totalCarbs, setTotalCarbs] = useState(carbohaydratePercentCal);
  let [protienCaloriesIntake, setProtienCaloriesIntake] = useState("");
  let [fatCaloriesIntake, setFatCaloriesIntake] = useState(0);
//   var [fatCaloriesIntake, setFatCaloriesIntake] = useState(0);
  let [carbCaloriesIntake, setCarbCaloriesIntake] = useState(0);
  let [carbsWeight, setCarbsWeight] = useState(0);
  const [calorieSummary, setCalorieSummary] = useState(0);
  const [filter_out_goal_idx, set_filter_out_goal_idx] = useState(0);
  const [manuallyAddProteinPerDayValue, setManuallyAddProtienPerDayValue] =
    useState(0);
  const [manuallyAddFatPerDayValue, setManuallyAddFatPerDayValue] = useState(0);
  const [manuallyAddCarbsPerDayValue, setManuallyAddCarbsPerDayValue] =
    useState(0);
  const [manuallyAddCaloriesPerDayValue, setManuallyAddCaloriesPerDayValue] =
    useState(0);
  const [kcal, setKcal] = useState(false);
  const [proteinBodyweightSliderInput, setProteinBodyweightSliderInput] =
    useState(false);
  const [proteinLeanmassSiderInput, setProteinLeanMassSliderInput] =
    useState(false);
  const [activityFactors, setActivityFactors] = useState([
    "1.2: Sedentary",
    "1.375: Lightly Active",
    "1.55: Moderately Active",
    "1.725: Very Active",
    "1.9: Extra Active or Athletes",
  ]);

  let [pieChartdata, setPieChartData] = useState([
    proteinCaloriesPerDay,
    fatCalories,
    carbohaydratePercentCal,
  ]);
  let calInfoSliderBackRef = useRef();
  let proteinSliderBgRef = useRef();
  let proteinLeanMassBgBgRef = useRef();
  let proteinCaloriesBgRef = useRef();
  let fatBgRef = useRef();
  let fatCaloriesBgRef = useRef();
  let carbsBgRef = useRef();
  let carbsCaloBgRef = useRef();

  useEffect(() => {
    let date = new Date();
    let todaydate = moment().format("YYYY-MM-DD");
    // console.log("dateddsd",moment().format("YYYY-MM-DD"))
    // debugger
    getMacrosData(id, todaydate, (result) => {
      // console.log("result", result);
      if (result) {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
        // setLoading(false);
        console.log("result get calculation", result, customGoalToolTip);
        setChoosedFactor(result.activity);
        setFat(result.bodyfat);
        setWeight(result?.weight);
        setCaloInfoSlider(result.calories);
        setCalorieSummary(result.calorieTarget);
        setCarboHyderatePerDay(result.carbsPerDay);
        setCarboHyderatePercentCal(result.carbsCalories);
        setFatSlider(result.fat);
        setFatCalories(result.fatCalories);
        setFatTDEE(result.fatPerDay);
        setLeanBodyMass(result.leanBodyMass);
        setProtienSlider(result.protein);
        setProteinLeanMass(result.proteinLean);
        setProteinCaloriesPerDay(result.proteinCalories);
        setProtienPerDay(result.proteinPerDay);
        setCalorieTarget(result?.calorieTarget);

        setGoalValue(result?.goalValue);
        // setSelectedGoal(result?.goalValue)
        let filter_goal_idx = customGoalToolTip.findIndex(
          (data) => data.value == result?.goalValue
        );
        console.log("filter out goal", filter_goal_idx);
        // let customGoalDefaultValue=result?.goalValue?customGoalToolTip[filter_goal_idx]:customGoalToolTip[-1]
        set_filter_out_goal_idx(filter_goal_idx);
        if (calInfoSliderBackRef.current) {
          calInfoSliderBackRef.current.style.backgroundSize =
            (parseFloat(result.calories) / 10000) * 100 + "%";
          // setCaloInfoSlider(result.calories);
        }
        if (proteinSliderBgRef.current) {
          proteinSliderBgRef.current.style.backgroundSize =
            (parseFloat(result?.protein) / 10) * 100 + "%";
          // setProtienSlider(result.protein)
        }
        if (proteinLeanMassBgBgRef.current) {
          proteinLeanMassBgBgRef.current.style.backgroundSize =
            (parseFloat(result?.proteinLean) / 10) * 100 + "%";
        }
        if (fatBgRef.current) {
          fatBgRef.current.style.backgroundSize =
            (parseFloat(result?.fat) / 5) * 100 + "%";
        }
        if (proteinCaloriesBgRef.current) {
          proteinCaloriesBgRef.current.style.backgroundSize =
            (parseFloat(result.protienCaloriesIntake) / 100) * 100 + "%";
        }
        if (fatCaloriesBgRef.current) {
          fatCaloriesBgRef.current.style.backgroundSize =
            (parseFloat(result.fatCaloriesIntake) / 100) * 100 + "%";
        }
        if (carbsCaloBgRef.current) {
          carbsCaloBgRef.current.style.backgroundSize =
            (parseFloat(result.carbCaloriesIntake) / 100) * 100 + "%";
        }
      } else {
        setLoading(false);
      }
    });
  }, [id, loading, filter_out_goal_idx]);

  const handelCalorieTarget = (e) => {
    // debugger;
    console.log(
      "eeee",
      e.label?.props?.children?.props?.children[0]?.props.children
    );
    setGoalValue(e.value);
    let selectedGoal = e.value;
    if (selectedGoal[0] == "+") {
      let parsedIntValue = parseInt(
        selectedGoal.substring(1, selectedGoal.length)
      );
      let targetCalories = parseInt(calInfoSlider) + parsedIntValue;
      // console.log("target calories", selectedGoal, targetCalories);
      setSelectedGoal(e.value);
      setCalorieTarget(targetCalories.toFixed(2));
      let sliderBgColor = proteinSlider
        ? (parseFloat(proteinCaloriesPerDay) / targetCalories) * 10
        : (parseFloat(proteinCaloriesPerDay) / targetCalories) * 100;
      proteinCaloriesBgRef.current.style.backgroundSize = sliderBgColor + "%";
      let fatCaloricCalculation = fatSlider
        ? (parseFloat(fatCalories) / targetCalories) * 5
        : (parseFloat(fatCalories) / targetCalories) * 100;
      fatCaloriesBgRef.current.style.backgroundSize =
        fatCaloricCalculation + "%";
      pieChartdata.splice(0, 1, sliderBgColor.toFixed(2));
      setPieChartData(pieChartdata);
      pieChartdata.splice(1, 1, fatCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);
      let carbo = calorieTarget - (proteinCaloriesPerDay + fatCalories);
      setCarboHyderatePercentCal(carbo.toFixed(2));
      //carbs section
      let perDayCarbo = carbo / 4;
      setCarboHyderatePerDay(perDayCarbo.toFixed(2));
      let carbCaloricCalculation = (parseInt(carbo) / calorieTarget) * 100;

      carbsCaloBgRef.current.style.backgroundSize =
        carbCaloricCalculation + "%";
      setCarbCaloriesIntake(Math.round(carbCaloricCalculation));
      pieChartdata.splice(2, 1, carbCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      setProtienCaloriesIntake(Math.round(sliderBgColor));
      setFatCaloriesIntake(Math.round(fatCaloricCalculation));
    } else if (selectedGoal[0] == "-") {
      let parsedIntValue = parseInt(
        selectedGoal.substring(1, selectedGoal.length)
      );
      let targetCalories = calInfoSlider - parsedIntValue;
      // console.log("target calories", selectedGoal, targetCalories);
      setSelectedGoal(e.value);
      setCalorieTarget(targetCalories.toFixed(2));
      let sliderBgColor = proteinSlider
        ? (parseFloat(proteinCaloriesPerDay) / targetCalories) * 10
        : (parseFloat(proteinCaloriesPerDay) / targetCalories) * 100;
      proteinCaloriesBgRef.current.style.backgroundSize = sliderBgColor + "%";
      let fatCaloricCalculation = fatSlider
        ? (parseFloat(fatCalories) / targetCalories) * 5
        : (parseFloat(fatCalories) / targetCalories) * 100;
      fatCaloriesBgRef.current.style.backgroundSize =
        fatCaloricCalculation + "%";
      pieChartdata.splice(0, 1, sliderBgColor.toFixed(2));
      setPieChartData(pieChartdata);
      pieChartdata.splice(1, 1, fatCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      //carbs
      let carbo = calorieTarget - (proteinCaloriesPerDay + fatCalories);
      setCarboHyderatePercentCal(carbo.toFixed(2));

      let perDayCarbo = carbo / 4;
      setCarboHyderatePerDay(perDayCarbo.toFixed(2));
      let carbCaloricCalculation = (parseInt(carbo) / calorieTarget) * 100;

      carbsCaloBgRef.current.style.backgroundSize =
        carbCaloricCalculation + "%";
      setCarbCaloriesIntake(Math.round(carbCaloricCalculation));
      pieChartdata.splice(2, 1, carbCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      setProtienCaloriesIntake(Math.round(sliderBgColor));
      setFatCaloriesIntake(Math.round(fatCaloricCalculation));
    } else {
      setSelectedGoal(e.value);
      setCalorieTarget(calInfoSlider);
      let sliderBgColor =
        (parseFloat(proteinCaloriesPerDay) / Math.round(calInfoSlider)) * 100;
      proteinCaloriesBgRef.current.style.backgroundSize = sliderBgColor + "%";
      let fatCaloricCalculation =
        (parseFloat(fatCalories) / Math.round(calInfoSlider)) * 100;
      fatCaloriesBgRef.current.style.backgroundSize =
        fatCaloricCalculation + "%";
      pieChartdata.splice(0, 1, sliderBgColor.toFixed(2));
      setPieChartData(pieChartdata);
      pieChartdata.splice(1, 1, fatCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      //carbs
      let carbo = calorieTarget - (proteinCaloriesPerDay + fatCalories);
      setCarboHyderatePercentCal(carbo.toFixed(2));

      let perDayCarbo = carbo / 4;
      setCarboHyderatePerDay(perDayCarbo.toFixed(2));
      let carbCaloricCalculation = (parseInt(carbo) / calorieTarget) * 100;

      carbsCaloBgRef.current.style.backgroundSize =
        carbCaloricCalculation + "%";
      setCarbCaloriesIntake(Math.round(carbCaloricCalculation));
      pieChartdata.splice(2, 1, carbCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      setProtienCaloriesIntake(Math.round(sliderBgColor));
      setFatCaloriesIntake(Math.round(fatCaloricCalculation));
    }
  };
  useEffect(() => {
    console.log("calorie target use effect", calorieTarget);
    if(proteinCaloriesPerDay||fatCalories){
    if (calorieTarget) {
      let fatCaloricCalculation =
        (parseFloat(fatCalories) / parseFloat(calorieTarget)) * 100;
      if (fatCaloriesBgRef.current) {
        fatCaloriesBgRef.current.style.backgroundSize =
          fatCaloricCalculation + "%";
      }

      setFatCaloriesIntake(Math.round(fatCaloricCalculation));
      let proteinCaloricCalculation =
        (parseFloat(proteinCaloriesPerDay) / parseFloat(calorieTarget)) * 100;
      if (proteinCaloriesBgRef.current) {
        proteinCaloriesBgRef.current.style.backgroundSize =
          proteinCaloricCalculation + "%";
      }
      setProtienCaloriesIntake(Math.round(proteinCaloricCalculation));
      pieChartdata.splice(0, 1, proteinCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);
      pieChartdata.splice(1, 1, fatCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);

      let carbo = calorieTarget - (proteinCaloriesPerDay + fatCalories);
      setCarboHyderatePercentCal(carbo.toFixed(2));

      let perDayCarbo = carbo / 4;
      setCarboHyderatePerDay(perDayCarbo.toFixed(2));
      let carbCaloricCalculation = (parseInt(carbo) / calorieTarget) * 100;
      if (carbsCaloBgRef.current) {
        carbsCaloBgRef.current.style.backgroundSize =
          carbCaloricCalculation + "%";
      }
      setCarbCaloriesIntake(Math.round(carbCaloricCalculation));
      pieChartdata.splice(2, 1, carbCaloricCalculation.toFixed(2));
      setPieChartData(pieChartdata);
    }}
//   }, []);
  }, [proteinCaloriesPerDay, fatCalories]);
  const data = {
    labels: ["Protein", "Fats", "Carbs"],
    datasets: [
      {
        label: "# of Votes",
        // data: [10, 10, 10],
        data: pieChartdata,
        backgroundColor: [
          "rgb(255, 196, 21)",
          "rgb(0, 189, 165)",
          "#000000",
          // 'rgba(54, 162, 235, 0.2)',
          // 'rgba(75, 192, 192, 0.2)',
          // 'rgba(153, 102, 255, 0.2)',
          // 'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          "rgb(255, 196, 21)",
          "rgb(0, 189, 165)",
          "#000000",
          // 'rgba(255, 99, 132, 1)',
          // 'rgba(54, 162, 235, 1)',
          // 'rgba(255, 206, 86, 1)',
          // 'rgba(75, 192, 192, 1)',
          // 'rgba(153, 102, 255, 1)',
          // 'rgba(255, 159, 64, 1)',
        ],
        // borderWidth: 1,
      },
    ],
  };

  useEffect(() => {
    // debugger
    // console.log("selected client", selectedClient);
    let { measurements, gender, date_of_birth, id } = selectedClient;
    let parseWeight = measurements ? measurements.weight : "Not Mention";
    let parseWeightToDecimelPoint = parseWeight.replace(/,/g, ".");
    // console.log("parse weight", parseWeightToDecimelPoint);
    // setWeight(measurements ? measurements.weight : "Not mention");
    setWeight(parseWeightToDecimelPoint);
    setHeight(measurements ? measurements.length : "Not mention");
    setChooseGender(gender);
    // let date=new
    setAge(moment().diff(date_of_birth.toDate(), "years"));
    // debugger
    set_client_id(id);
    // console.log("seleeeected client props", selectedClient);
  }, [selectedClient]);

  let addCalulation = () => {
    // debugger;
    setLoading(true);

    let content = {
      protein: proteinSlider,
      proteinLean: proteinLeanMass,
      proteinPerDay: protienPerDay,
      proteinCalories: proteinCaloriesPerDay,
      fat: fatSlider,
      fatPerDay: fatTDEE,
      fatCalories: fatCalories,
      carbsPerDay: carbohaydratePerDay,
      carbsCalories: carbohaydratePercentCal,
      age: age,
      weight: weight,
      height: height,
      calories: calInfoSlider,
      activity: choosedFactor,
      bodyfat: fat,
      goalValue: goalValue,
      leanBodyMass: leanBodyMass || 0,
      calorieTarget: calorieTarget ? calorieTarget : calInfoSlider,
      protienCaloriesIntake: protienCaloriesIntake,
      fatCaloriesIntake: fatCaloriesIntake,
      carbCaloriesIntake: carbCaloriesIntake,
      weight: weight,
    };
    let todatyDate = new Date();
    let date = moment(todatyDate).format("YYYY-MM-DD");
    // console.log("ddddd",moment(todatyDate).format("YYYY-MM-DD"))
    addMacros(client_id, date, content, (e) => {
      // setLoading(false);

      // console.log("eeeee", e);
      setProteinCaloriesPerDay(0.0);
      setProteinLeanMass(0.0);
      setProtienSlider(0);
      setProtienPerDay(0.0);
      setFatTDEE(0.0);
      setCaloInfoSlider(0);
      setFatSlider(0);
      setFatCalories(0.0);
      setCarboHyderatePercentCal(0.0);
      setCarboHyderatePerDay(0.0);
      setActivityFactors("Select Activity");
      setLoading(false);
      window.location.reload()
      // navigation.goBack();
    });
    // addMacros(id,content)
  };
  const handelCarbsPerDay = (e) => {
    let val = parseInt(e.target.value);
    // console.log("carbs perday input", val);
    setCarboHyderatePerDay(val);
  };
  useEffect(() => {
    // debugger
    //protein per day
    let tenPercentOfTotal = calInfoSlider / 10;
    let thirtyFiveOfTotal = calInfoSlider / 35;

    // let result = tenPercentOfTotal - thirtyFiveOfTotal
    let result = protienPerDay ? protienPerDay : 0;
    let protCal;
    // console.log("result", result, tenPercentOfTotal, thirtyFiveOfTotal)
    // let reCalcLeanMass=(370+(proteinLeanMass*leanBodyMass))
    if (leanBodyMass && proteinLeanMass) {
      // debugger
      if (protienPerDay) {
        // protCal = 4 * result;
        protCal = 4 * Math.round(result);
        setProteinCaloriesPerDay(Math.round(protCal));

        let ProteinCaloriesInPercentage =
          (protCal / parseFloat(calorieTarget)) * 100;
        // let ProteinCaloriesInPercentage = proteinLeanMass
        //   ? (protCal / parseFloat(calorieTarget)) * 10
        //   : (protCal / parseFloat(calorieTarget)) * 100;
        // console.log("prot calories", ProteinCaloriesInPercentage);
        if (proteinCaloriesBgRef.current) {
          proteinCaloriesBgRef.current.style.backgroundSize =
            ProteinCaloriesInPercentage + "%";
        }

        setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      } else {
        // debugger
        result = leanBodyMass * proteinLeanMass;
        result = Math.round(result);
        setProtienPerDay(Math.round(result));
        protCal = 4 * result;
        setProteinCaloriesPerDay(Math.round(protCal));
        console.log("result", result, leanBodyMass);
        let ProteinCaloriesInPercentage =
          (protCal / parseFloat(calorieTarget)) * 100;
        // let ProteinCaloriesInPercentage = proteinLeanMass
        //   ? (protCal / parseFloat(calorieTarget)) * 10
        //   : (protCal / parseFloat(calorieTarget)) * 100;
        // console.log("prot calories", ProteinCaloriesInPercentage);
        if (proteinCaloriesBgRef.current) {
          proteinCaloriesBgRef.current.style.backgroundSize =
            ProteinCaloriesInPercentage + "%";
        }
        setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      }
    } else if (leanBodyMass && protienPerDay && proteinSlider) {
      // debugger;
      let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
      result = proteinSlider * parseInt(parseWeightToDecimelPoint);
      setProtienPerDay(Math.round(result));
      protCal = 4 * result;
      setProteinCaloriesPerDay(Math.round(protCal));

      let ProteinCaloriesInPercentage =
        (protCal / parseFloat(calorieTarget)) * 100;
      // let ProteinCaloriesInPercentage = proteinSlider
      //   ? (protCal / parseFloat(calorieTarget)) * 10
      //   : (protCal / parseFloat(calorieTarget)) * 100;
      // console.log("prot calories", ProteinCaloriesInPercentage);
      if (proteinCaloriesBgRef.current) {
        proteinCaloriesBgRef.current.style.backgroundSize =
          ProteinCaloriesInPercentage + "%";
      }
      setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
      pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
      setPieChartData(pieChartdata);
    } else if (leanBodyMass && protienPerDay) {
      protCal = 4 * result;
      setProteinCaloriesPerDay(Math.round(protCal));

      let ProteinCaloriesInPercentage =
        (protCal / parseFloat(calorieTarget)) * 100;
      // console.log("prot calories", ProteinCaloriesInPercentage);
      if (proteinCaloriesBgRef.current) {
        proteinCaloriesBgRef.current.style.backgroundSize =
          ProteinCaloriesInPercentage + "%";
      }
      setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
      pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
      setPieChartData(pieChartdata);
    } else if (proteinSlider) {
      // debugger;
      let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
      result = proteinSlider * parseInt(parseWeightToDecimelPoint);
      // console.log("result",result)
      // result = proteinSlider * parseInt(weight);
      setProtienPerDay(Math.round(result));
      protCal = 4 * result;
      setProteinCaloriesPerDay(Math.round(protCal));

      let ProteinCaloriesInPercentage =
        (protCal / parseFloat(calorieTarget)) * 100;
      // let ProteinCaloriesInPercentage = proteinSlider
      //   ? (protCal / parseFloat(calorieTarget)) * 10
      //   : (protCal / parseFloat(calorieTarget)) * 100;
      // console.log("prot calories", ProteinCaloriesInPercentage);
      if (proteinCaloriesBgRef.current) {
        proteinCaloriesBgRef.current.style.backgroundSize =
          ProteinCaloriesInPercentage + "%";
      }
      setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
      pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
      setPieChartData(pieChartdata);
    } else if (protienPerDay) {
      protCal = 4 * result;
      setProteinCaloriesPerDay(Math.round(protCal));

      let ProteinCaloriesInPercentage =
        (protCal / parseFloat(calorieTarget)) * 100;
      // console.log("prot calories", ProteinCaloriesInPercentage);
      if (proteinCaloriesBgRef.current) {
        proteinCaloriesBgRef.current.style.backgroundSize =
          ProteinCaloriesInPercentage + "%";
      }
      setProtienCaloriesIntake(ProteinCaloriesInPercentage.toFixed(2));
      pieChartdata.splice(0, 1, ProteinCaloriesInPercentage.toFixed(2));
      setPieChartData(pieChartdata);
    } else {
      // debugger
      if (protienPerDay) {
        protCal = 4 * result;
        setProteinCaloriesPerDay(Math.round(protCal));
        pieChartdata.splice(0, 1, protCal);
        setPieChartData(pieChartdata);
      } else {
        let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
        result = proteinSlider * parseInt(parseWeightToDecimelPoint);
        // result = proteinSlider * parseInt(weight);
        setProtienPerDay(Math.round(result));
        protCal = 4 * result;
        setProteinCaloriesPerDay(Math.round(protCal));
        pieChartdata.splice(0, 1, protCal);
        setPieChartData(pieChartdata);
      }
    }

    let fat = fatTDEE ? fatTDEE : 0;
    let fatCalo;
    let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");

    if (parseInt(parseWeightToDecimelPoint)) {
      if (fatTDEE) {
        // fat = (weight * fatSlider);
        fatCalo = 9 * fatTDEE;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        let fatCaloriesInPercentage =
          (fatCalo / parseFloat(calorieTarget)) * 100;
        if (fatCaloriesBgRef.current) {
          fatCaloriesBgRef.current.style.backgroundSize =
            fatCaloriesInPercentage + "%";
        }
        setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      } else {
        // debugger
        fat = weight * fatSlider;
        fatCalo = 9 * fat;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        if (fatCalo > 0) {
          let fatCaloriesInPercentage =
            (fatCalo / parseFloat(calorieTarget)) * 100;
          // let fatCaloriesInPercentage = fatSlider
          //   ? (fatCalo / parseFloat(calorieTarget)) * 5
          //   : (fatCalo / parseFloat(calorieTarget)) * 100;
          if (fatCaloriesBgRef.current) {
            fatCaloriesBgRef.current.style.backgroundSize =
              fatCaloriesInPercentage + "%";
          }
          setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
          pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
          setPieChartData(pieChartdata);
        }
      }
    } else {
      // debugger
      if (fatTDEE) {
        // fat = fatSlider * leanBodyMass
        fatCalo = 9 * fatTDEE;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        let fatCaloriesInPercentage =
          (fatCalo / parseFloat(calorieTarget)) * 100;
        // let fatCaloriesInPercentage = fatSlider
        //   ? (fatCalo / parseFloat(calorieTarget)) * 5
        //   : (fatCalo / parseFloat(calorieTarget)) * 100;
        if (fatCaloriesBgRef.current) {
          fatCaloriesBgRef.current.style.backgroundSize =
            fatCaloriesInPercentage + "%";
        }
        setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      } else {
        // debugger
        fat = fatSlider * leanBodyMass;
        fatCalo = 9 * fat;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        if (fatCalo > 0) {
          let fatCaloriesInPercentage =
            (fatCalo / parseFloat(calorieTarget)) * 100;
          // let fatCaloriesInPercentage = fatSlider
          //   ? (fatCalo / parseFloat(calorieTarget)) * 5
          //   : (fatCalo / parseFloat(calorieTarget)) * 100;
          if (fatCaloriesBgRef.current) {
            fatCaloriesBgRef.current.style.backgroundSize =
              fatCaloriesInPercentage + "%";
          }
          setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
          pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
          setPieChartData(pieChartdata);
        }
      }
    }
    if (fatSlider) {
      if (parseWeightToDecimelPoint) {
        // fat = weight * fatSlider;
        fat = parseWeightToDecimelPoint * fatSlider;
        fatCalo = 9 * fat;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        let fatCaloriesInPercentage =
          (fatCalo / parseFloat(calorieTarget)) * 100;
        // let fatCaloriesInPercentage = fatSlider
        //   ? (fatCalo / parseFloat(calorieTarget)) * 5
        //   : (fatCalo / parseFloat(calorieTarget)) * 100;
        if (fatCaloriesBgRef.current) {
          fatCaloriesBgRef.current.style.backgroundSize =
            fatCaloriesInPercentage + "%";
        }
        setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      } else {
        fat = fatSlider * leanBodyMass;
        fatCalo = 9 * fat;
        setFatTDEE(Math.round(fat));
        setFatCalories(Math.round(fatCalo));

        let fatCaloriesInPercentage =
          (fatCalo / parseFloat(calorieTarget)) * 100;
        // let fatCaloriesInPercentage = fatSlider
        //   ? (fatCalo / parseFloat(calorieTarget)) * 5
        //   : (fatCalo / parseFloat(calorieTarget)) * 100;
        if (fatCaloriesBgRef.current) {
          fatCaloriesBgRef.current.style.backgroundSize =
            fatCaloriesInPercentage + "%";
        }
        setFatCaloriesIntake(fatCaloriesInPercentage.toFixed(2));
        pieChartdata.splice(1, 1, fatCaloriesInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      }
    }

    let carbo;

    // console.log("fatsss", fatCalories,fat,)

    if (carbsWeight) {
      let result = carbsWeight * parseInt(parseWeightToDecimelPoint);
      setCarboHyderatePerDay(Math.round(result));
      let carboCal = 4 * result;
      setCarboHyderatePercentCal(Math.round(carboCal));
      let carbsCalorieInPercentage =
        (carboCal / parseFloat(calorieTarget)) * 100;
      // let carbsCalorieInPercentage = fatSlider
      //   ? (carbo / parseFloat(calInfoSlider)) * 10
      //   : (carbo / parseFloat(calInfoSlider)) * 100;
      if (carbsCaloBgRef.current) {
        carbsCaloBgRef.current.style.backgroundSize =
          carbsCalorieInPercentage < 0
            ? 0 + "%"
            : carbsCalorieInPercentage + "%";
      }
      setCarbCaloriesIntake(carbsCalorieInPercentage.toFixed(2));
      pieChartdata.splice(2, 1, carbsCalorieInPercentage.toFixed(2));
      setPieChartData(pieChartdata);
    } else {
      // debugger
      // console.log("protien calories", protCal, "fat calories", fatCalo);
      // carbo = calInfoSlider - (protCal + fatCalo);
      carbo = calorieTarget - (protCal + fatCalo);
      setCarboHyderatePercentCal(Math.round(carbo));

      let perDayCarbo = carbo / 4;
      setCarboHyderatePerDay(Math.round(perDayCarbo));

      if (carbo > 0) {
        let carbsCalorieInPercentage =
          (carbo / parseFloat(calorieTarget)) * 100;
        // let carbsCalorieInPercentage = fatSlider
        //   ? (carbo / parseFloat(calInfoSlider)) * 10
        //   : (carbo / parseFloat(calInfoSlider)) * 100;
        if (carbsCaloBgRef.current) {
          carbsCaloBgRef.current.style.backgroundSize =
            carbsCalorieInPercentage < 0
              ? 0 + "%"
              : carbsCalorieInPercentage + "%";
        }
        setCarbCaloriesIntake(carbsCalorieInPercentage.toFixed(2));
        pieChartdata.splice(2, 1, carbsCalorieInPercentage.toFixed(2));
        setPieChartData(pieChartdata);
      }
    }

    if (proteinCaloriesPerDay && fatCalories && carbohaydratePercentCal) {
      let calcSummary = parseInt(
        parseInt(proteinCaloriesPerDay) +
          parseInt(fatCalories) +
          parseInt(carbohaydratePercentCal)
      );
      setCalorieSummary(calcSummary);
    }

    // handleChoosedFactor(choosedFactor,leanBodyMass)
  }, [
    carbsWeight,
    carbohaydratePerDay,
    calInfoSlider,
    // fatTDEE,
    leanBodyMass,
    proteinSlider,
    proteinLeanMass,
    fatSlider,
    chooseGender,
    weight,
    height,
    // protienPerDay,
    // protienCaloriesIntake
    // choosedFactor
  ]);
  const handleChangeProtienSlider = (e) => {
    // proteinSlider++
    setCarbsWeight(0);
    if (carbsBgRef.current) {
      carbsBgRef.current.style.backgroundSize = 0 + "%";
    }
    let val = parseFloat(e.target.value);
    // let sliderBgColor= (((val*2)*10)+"%")
    setProtienSlider(val);
    let sliderBgColor = (val / 10) * 100 + "%";
    // if (proteinLeanMass > 0 || protienPerDay > 0) {
    if (proteinLeanMass > 0 && protienPerDay > 0) {
      setProteinLeanMass(0);
      setLeanBodyMass("lean body mass");

      setProtienPerDay(0);

      setProtienSlider(0);
      proteinSliderBgRef.current.style.backgroundSize = 0 + "%";
    } else if (protienPerDay > 0) {
      setProtienSlider(val);
      proteinSliderBgRef.current.style.backgroundSize = sliderBgColor;
      proteinLeanMassBgBgRef.current.style.backgroundSize = 0 + "%";
    } else {
      //   debugger;
      setProteinLeanMass(0);
      setProtienSlider(val);

      proteinLeanMassBgBgRef.current.style.backgroundSize = 0 + "%";
      proteinSliderBgRef.current.style.backgroundSize = sliderBgColor;

      // console.log("protein slider bg ref background",parseFloat(e.target.value))
    }
  };

  const handelCarbsWeight = (e) => {
    // debugger;
    let parsedCarbWeight = parseFloat(e.target.value);
    let sliderBgColor = (parsedCarbWeight / 15) * 100 + "%";
    carbsBgRef.current.style.backgroundSize = sliderBgColor;
    setCarbsWeight(parsedCarbWeight);
    let carbsCalorieInPercentage = e.target.value
      ? (carbohaydratePercentCal / calorieTarget) * 15
      : (carbohaydratePercentCal / calorieTarget) * 100;
    carbsCaloBgRef.current.style.backgroundSize =
      carbsCalorieInPercentage + "%";
    setCarbCaloriesIntake(carbsCalorieInPercentage);
  };
  const handleFatSlider = (e) => {
    // let date=new Date()
    // date.getDate(dob.setSeconds(945216000)
    let val = parseFloat(e.target.value);
    // console.log("fat slider value", e.target.value);
    let sliderBgColor = (val / 5) * 100 + "%";
    fatBgRef.current.style.backgroundSize = sliderBgColor;
    setFatSlider(val);
    // if (fatTDEE > 0) {
    //   setFatTDEE(0);
    // } else {
    //   setFatSlider(e.target.value);
    // }
  };
  const handleChangeCalSlider = (e) => {
    // console.log("slider val", e.target.value);
    let val = parseInt(e.target.value);
    val += 10;
    let sliderBgColor = val / 100;
    setCaloInfoSlider(val);
    calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor + "%";
    // console.log("linear background",calInfoSliderBackRef.current.style.backgroundSize=sliderBgColor+"%")
  };
  const handelProteinClaoriesIntake = (e) => {
    // let commaVal=e.target.value
    // let parseCommaVal= commaVal.toString()?.replace(/,/g, ".");
    let val = parseFloat(e.target.value);
    // console.log("parse comma val",val,e.target.value,protienCaloriesIntake)
    setProtienCaloriesIntake(val);
    proteinCaloriesBgRef.current.style.backgroundSize = val + "%";
    let calculateCaloricIntakePercentage = val / 100;
    let protPerDayCalories =
      calculateCaloricIntakePercentage * parseInt(calorieTarget);
    // setProtienPerDay(protPerDayCalculation)
    // console.log("protPerDayCalculation", protPerDayCalories);

    setProtienPerDay(protPerDayCalories / 4);
    setProteinCaloriesPerDay(protPerDayCalories);
  };

  const handleCarbsCalories = (e) => {
    let val = parseInt(e.target.value);
    carbsCaloBgRef.current.style.backgroundSize = val + "%";
    // setCarbsCaloriesIntake(val);
    setCarbCaloriesIntake(val);
  };
  let handleLeanBodyMass = (e) => {
    let manCalMassForm = 0.3281 * weight + 0.33929 * height - 29.5336;
  };

  let handleProteinLeanMass = (e) => {
    // setProteinLeanMass(e.target.value)
    let val = parseFloat(e.target.value);
    // console.log("protein lean mass slider bg color val", val);
    let sliderBgColor = (val / 10) * 100 + "%";
    if (proteinSlider > 0 || protienPerDay > 0) {
      setProtienSlider(0);
      setProtienPerDay(0);
      setProteinLeanMass(val);
      proteinLeanMassBgBgRef.current.style.backgroundSize = sliderBgColor;
      proteinSliderBgRef.current.style.backgroundSize = 0 + "%";
    } else {
      setProteinLeanMass(val);
      proteinSliderBgRef.current.style.backgroundSize = 0 + "%";
      proteinLeanMassBgBgRef.current.style.backgroundSize = sliderBgColor;
    }
  };

  const handelFatCaloriesIntake = (e) => {
    debugger
    const val = parseInt(e.target.value);
    let sliderBgColor = (val / 100) * 100 + "%";
    fatCaloriesBgRef.current.style.backgroundSize = sliderBgColor;
    setFatCaloriesIntake(val);
    let calculateCaloricIntakePercentage = val / 100;
    let fatPerDayCalories =
      calculateCaloricIntakePercentage * parseInt(calorieTarget);
    // setProtienPerDay(protPerDayCalculation)
    // console.log("fatPerDayCalculation", fatPerDayCalories);
    setFatTDEE(fatPerDayCalories / 9);
    setFatCalories(fatPerDayCalories);
  };
  useEffect(() => {
    // debugger
    if (parseInt(fat)) {
      // setFat(e)
      let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
      // const bodyFatPer = weight * (parseInt(fat) / 100);
      const bodyFatPer =
        parseFloat(parseWeightToDecimelPoint) * (parseInt(fat) / 100);

      const leanMass = parseFloat(
        parseFloat(parseWeightToDecimelPoint) - bodyFatPer
      ); //old calcualation

      const LBMCal = 370 + 21.6 * leanMass;
      setLeanBodyMass(leanMass);
      // let factor = e
      // setChoosedFactor(factor)
      let calFormula;
      if (chooseGender == "Male") {
        // calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
        calFormula =
          66.5 +
          13.75 * parseFloat(leanMass ? leanMass : weight) +
          5.003 * parseFloat(height) -
          6.755 * parseFloat(age);
        if (choosedFactor === "Sedentary") {
          // let result = ((calFormula*LBMCal) * 1.2);
          let result = LBMCal * 1.2;
          // setCaloInfoSlider(result.toFixed(2));
          setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        } else if (choosedFactor === "Lightly Active") {
          // let result = ((calFormula*LBMCal) * 1.375);
          let result = LBMCal * 1.375;
          setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
        } else if (choosedFactor === "Moderately Active") {
          let result = LBMCal * 1.55;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        } else if (choosedFactor === "Very Active") {
          let result = LBMCal * 1.725;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        } else if (choosedFactor === "Extra Active or Athletes") {
          let result = LBMCal * 1.9;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        }
      } else {
        // calFormula = (((((10 * parseInt(leanMass?leanMass:weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
        calFormula = calFormula =
          655 +
          9.563 * parseFloat(leanMass ? leanMass : parseWeightToDecimelPoint) +
          1.85 * parseFloat(height) -
          4.676 * parseFloat(age);
        if (choosedFactor === "Sedentary") {
          // let result = calFormula * 1.2;
          let result = LBMCal * 1.2;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        } else if (choosedFactor === "Lightly Active") {
          let result = LBMCal * 1.375;
          let sliderBgColor = result / 100 + "%";
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        } else if (choosedFactor === "Moderately Active") {
          let result = LBMCal * 1.55;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result);
        } else if (choosedFactor === "Very Active") {
          let result = LBMCal * 1.725;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        } else if (choosedFactor === "Extra Active or Athletes") {
          let result = LBMCal * 1.9;
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(result.toFixed(2));
        }
      }
    } else {
      // debugger
      setFat(0);
      setLeanBodyMass(0.0);
      // let factor = e
      // setChoosedFactor(factor)
      let calFormula;
      if (chooseGender == "Male") {
        // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 5))
        // calFormula =
        //   66.5 +
        //   13.75 * parseFloat(weight) +
        //   5.003 * parseFloat(height) -
        //   6.755 * parseFloat(age);
        let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
        calFormula =
          10 * parseFloat(parseWeightToDecimelPoint) +
          6.25 * parseFloat(height) -
          5 * parseFloat(age) +
          5;
        if (choosedFactor === "Sedentary") {
          let result = calFormula * 1.2;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Lightly Active") {
          let result = calFormula * 1.375;
          //   debugger;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Moderately Active") {
          let result = calFormula * 1.55;
          // setCaloInfoSlider(result);
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Very Active") {
          let result = calFormula * 1.725;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Extra Active or Athletes") {
          let result = calFormula * 1.9;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        }
      } else {
        // calFormula = (((((10 * parseInt(weight)) + (6.25 * parseInt(height))) - (5 * parseInt(age))) + 161))
        // calFormula =
        //   655 +
        //   9.563 * parseFloat(weight) +
        //   1.85 * parseFloat(height) -
        //   4.676 * parseFloat(age);
        let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
        calFormula =
          10 * parseFloat(parseWeightToDecimelPoint) +
          6.25 * parseFloat(height) -
          5 * parseFloat(age) -
          161;
        if (choosedFactor === "Sedentary") {
          let result = calFormula * 1.2;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Lightly Active") {
          let result = calFormula * 1.375;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Moderately Active") {
          let result = calFormula * 1.55;
          // setCaloInfoSlider(result);
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Very Active") {
          let result = calFormula * 1.725;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        } else if (choosedFactor === "Extra Active or Athletes") {
          let result = calFormula * 1.9;
          // setCaloInfoSlider(result.toFixed(2));
          let sliderBgColor = result / 100 + "%";
          // calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          if (calInfoSliderBackRef.current) {
            calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
          }
          setCaloInfoSlider(Math.round(result));
        }
      }
    }
  }, [weight, leanBodyMass, fat]);
  const handleChoosedFactor = (e) => {
    // debugger;
    // setFat(0);
    // setLeanBodyMass(0.0);
    let factor = e;
    setChoosedFactor(factor);
    let calFormula;
    let bodyFatPer = weight * (parseInt(fat) / 100);
    let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
    let leanMass = parseFloat(parseWeightToDecimelPoint - bodyFatPer); //old calcualation
    let LBMCal = 370 + 21.6 * leanMass;
    setLeanBodyMass(leanMass);
    if (chooseGender == "Male") {
      // (10 × weight in kg) + (6.25 × height in cm) - (5 × age in years) + 5
      // calFormula =66.5 + 13.75 * parseFloat(weight) +5.003 * parseFloat(height) -6.755 * parseFloat(age);
      calFormula =
        10 * parseFloat(parseWeightToDecimelPoint) +
        6.25 * parseFloat(height) -
        5 * parseFloat(age) +
        5;

      if (e === "Sedentary") {
        // debugger
        let result = parseInt(fat) ? LBMCal * 1.2 : calFormula * 1.2;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
        // setSelectedGoal("Maintenance calories")
        // handelCalorieTarget({value:"0"})
      } else if (e === "Lightly Active") {
        // debugger
        let result = parseInt(fat) ? LBMCal * 1.375 : calFormula * 1.375;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Moderately Active") {
        let result = parseInt(fat) ? LBMCal * 1.55 : calFormula * 1.55;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result);
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Very Active") {
        let result = parseInt(fat) ? LBMCal * 1.725 : calFormula * 1.725;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Extra Active or Athletes") {
        let result = parseInt(fat) ? LBMCal * 1.9 : calFormula * 1.9;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      }
    } else {
      // calFormula =
      //   655 +
      //   9.563 * parseFloat(weight) +
      //   1.85 * parseFloat(height) -
      //   4.676 * parseFloat(age);
      // (10 × weight in kg) + (6.25 × height in cm) - (5 × age in years) - 161
      let parseWeightToDecimelPoint = weight?.replace(/,/g, ".");
      calFormula =
        10 * parseFloat(parseWeightToDecimelPoint) +
        6.25 * parseFloat(height) -
        5 * parseFloat(age) -
        161;
      if (e === "Sedentary") {
        let result = parseInt(fat) ? LBMCal * 1.2 : calFormula * 1.2;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Lightly Active") {
        let result = parseInt(fat) ? LBMCal * 1.375 : calFormula * 1.375;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Moderately Active") {
        let result = parseInt(fat) ? LBMCal * 1.55 : calFormula * 1.55;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result);
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(result.toFixed(2));
      } else if (e === "Very Active") {
        let result = parseInt(fat) ? LBMCal + 1.725 : calFormula * 1.725;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(Math.round(result));
      } else if (e === "Extra Active or Athletes") {
        let result = parseInt(fat) ? LBMCal * 1.9 : calFormula * 1.9;
        let sliderBgColor = result / 100 + "%";
        calInfoSliderBackRef.current.style.backgroundSize = sliderBgColor;
        // setCaloInfoSlider(result.toFixed(2));
        setCaloInfoSlider(Math.round(result));
        setTotalCalories(Math.round(result));
      }
    }
  };
  const handleBodyFat = (e) => {
    // debugger
    // console.log("body fat", e);
    setFat(e);
    const bodyFatPer = weight * (parseInt(e) / 100);
    const leanMass = parseFloat(weight - bodyFatPer);
    setLeanBodyMass(leanMass);
    // let factor = e
    // setChoosedFactor(factor)
    let calFormula;
    if (chooseGender == "Male") {
      calFormula =
        10 * parseInt(leanMass ? leanMass : weight) +
        6.25 * parseInt(height) -
        5 * parseInt(age) +
        5;
      if (choosedFactor === "Sedentary") {
        let result = calFormula * 1.2;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Lightly Active") {
        let result = calFormula * 1.375;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Moderately Active") {
        let result = calFormula * 1.55;
        setCaloInfoSlider(result);
      } else if (choosedFactor === "Very Active") {
        let result = calFormula * 1.725;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Extra Active or Athletes") {
        let result = calFormula * 1.9;
        setCaloInfoSlider(result.toFixed(2));
      }
    } else {
      calFormula =
        10 * parseInt(leanMass ? leanMass : weight) +
        6.25 * parseInt(height) -
        5 * parseInt(age) +
        161;
      if (choosedFactor === "Sedentary") {
        let result = calFormula * 1.2;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Lightly Active") {
        let result = calFormula * 1.375;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Moderately Active") {
        let result = calFormula * 1.55;
        setCaloInfoSlider(result);
      } else if (choosedFactor === "Very Active") {
        let result = calFormula * 1.725;
        setCaloInfoSlider(result.toFixed(2));
      } else if (choosedFactor === "Extra Active or Athletes") {
        let result = calFormula * 1.9;
        setCaloInfoSlider(result.toFixed(2));
      }
    }
  };

  const calcProteinPerdayCaloriesByformula = (val) => {
    // debugger
    let calculateCaloricIntakePercentage = val / 100;
    let protPerDayCalories =
      calculateCaloricIntakePercentage * parseInt(calorieTarget);
    setProtienPerDay(protPerDayCalories / 4);
    setProteinCaloriesPerDay(protPerDayCalories);
    // console.log("protPerDayCalculation", protPerDayCalories);
  };
  const calcFatCaloriesPerdayByformula = (val) => {
    let calculateCaloricIntakePercentage = val / 100;
    let protPerDayCalories =
      calculateCaloricIntakePercentage * parseInt(calorieTarget);
    setFatTDEE(protPerDayCalories / 9);
    setFatCalories(protPerDayCalories);
    // console.log("fatPerDayCalculation", protPerDayCalories);
  };

  let minProteinBodyWeightBtn = () => {
    if (proteinSlider === 0.0) {
      setProtienSlider(0.0);
    } else {
      proteinSlider = parseFloat(proteinSlider);
      let sliderBgColor = (proteinSlider / 10) * 100 + "%";
      proteinSliderBgRef.current.style.backgroundSize = sliderBgColor;
      setProtienSlider((proteinSlider -= 0.1));
    }
  };
  const decrementEnergyExpandHandel = () => {
    calInfoSlider == 0 ? setCaloInfoSlider(0) : (calInfoSlider -= 10);
    calInfoSliderBackRef.current.style.backgroundSize =
      calInfoSlider / 100 + "%";
    setCaloInfoSlider(calInfoSlider);
  };

  const incrementEnergyExpandHandel = () => {
    calInfoSlider += 10;
    calInfoSliderBackRef.current.style.backgroundSize =
      calInfoSlider / 100 + "%";
    setCaloInfoSlider(calInfoSlider);
  };
  const maxProteinBodyWeight = () => {
    // debugger
    let parsedVal = parseFloat(proteinSlider);
    // console.log(
    //   "protien slider val check",
    //   parseInt(proteinSlider)
    // );
    let sliderBgColor = (parsedVal / 10) * 100 + "%";
    proteinSliderBgRef.current.style.backgroundSize = sliderBgColor;
    parsedVal = parsedVal + 0.1;
    setProtienSlider(parsedVal);
  };

  const minLeanBodymassRange = () => {
    if (proteinLeanMass == 0.0) {
      setProteinLeanMass(0.0);
    } else {
      proteinLeanMass = parseFloat(proteinLeanMass);
      let sliderBgColor = (proteinLeanMass / 10) * 100 + "%";
      proteinLeanMassBgBgRef.current.style.backgroundSize = sliderBgColor;
      setProteinLeanMass((proteinLeanMass -= 0.1));
      setProtienPerDay(proteinLeanMass * leanBodyMass);
      setProteinCaloriesPerDay(protienPerDay * 4);
    }
  };

  const maxLeanBodymassRange = () => {
    proteinLeanMass = parseFloat(proteinLeanMass);
    let sliderBgColor = (proteinLeanMass / 10) * 100 + "%";
    proteinLeanMassBgBgRef.current.style.backgroundSize = sliderBgColor;
    setProteinLeanMass((proteinLeanMass += 0.1));
    setProtienPerDay(proteinLeanMass * leanBodyMass);
    setProteinCaloriesPerDay(protienPerDay * 4);
  };
  const minCaloricIntakePercentage = () => {
    if (protienCaloriesIntake > 0) {
        let parsedCaloricValue=parseInt(protienCaloriesIntake)
    parsedCaloricValue=parsedCaloricValue-1
      setProtienCaloriesIntake(parsedCaloricValue);
      proteinCaloriesBgRef.current.style.backgroundSize =
      parsedCaloricValue + "%";
      calcProteinPerdayCaloriesByformula(parsedCaloricValue);
    } else {
      console.log("caloric percent is equal to 0");
    }
  };
  const maxCaloricIntakePercentage = () => {
    // debugger
    // console.log("max caloric protein",protienCaloriesIntake)
    let parsedCaloricValue=parseInt(protienCaloriesIntake)
    parsedCaloricValue=parsedCaloricValue+1
    setProtienCaloriesIntake(parsedCaloricValue);
    proteinCaloriesBgRef.current.style.backgroundSize =
    parsedCaloricValue + "%";
    calcProteinPerdayCaloriesByformula(parsedCaloricValue);
  };
  const minFatBodyWeight = () => {
    let sliderBgColor = (fatSlider / 5) * 100 + "%";
    fatBgRef.current.style.backgroundSize = sliderBgColor;
    fatSlider == 0.0 ? setFatSlider(0.0) : setFatSlider((fatSlider -= 0.1));
  };
  const maxFatBodyWeight = () => {
    fatSlider = parseFloat(fatSlider);
    let sliderBgColor = (fatSlider / 5) * 100 + "%";
    fatBgRef.current.style.backgroundSize = sliderBgColor;
    setFatSlider((fatSlider += 0.1));
  };
  const minFatCaloricPercentage = () => {
    if(fatCaloriesIntake > 0)
       {
        let parsedFatCaloricValue=parseInt(fatCaloriesIntake)
    parsedFatCaloricValue=parsedFatCaloricValue-1
          setFatCaloriesIntake(parsedFatCaloricValue);
          fatCaloriesBgRef.current.style.backgroundSize =
          parsedFatCaloricValue+ "%";
          calcFatCaloriesPerdayByformula(parsedFatCaloricValue);
        }
      else{
        console.log("fat calorise are equal to 0")
      }
  };
  const maxFatCaloricPercentage = () => {
    // debugger
    // console.log("fat calories",fatCaloriesIntake)
    let parsedFatCaloricValue=parseInt(fatCaloriesIntake)
    parsedFatCaloricValue=parsedFatCaloricValue+1
        setFatCaloriesIntake(parsedFatCaloricValue);
        fatCaloriesBgRef.current.style.backgroundSize =
        parsedFatCaloricValue + "%";
        calcFatCaloriesPerdayByformula(
            parsedFatCaloricValue
        );
      
  };

  const minCarbsBodyWeight=()=>{
    
        if (carbsWeight > 0.0) {
          let parsedVal = parseFloat(carbsWeight);
          carbsBgRef.current.style.backgroundSize =
            (parsedVal / 15) * 100 + "%";
          parsedVal = parsedVal - 0.1;
          setCarbsWeight(parsedVal);
        }
      
  }
  const maxCarbsBodyWeight=()=>{
    
        // debugger
        let parsedVal = parseFloat(carbsWeight);
        carbsBgRef.current.style.backgroundSize =
          (parsedVal / 15) * 100 + "%";
        parsedVal = parsedVal + 0.1;
        setCarbsWeight(parsedVal);
      
  }
  const minCarbsCaloricPercentage=()=>{
    
        if (carbCaloriesIntake == 0) {
          setCarbCaloriesIntake(0);
        } else {
          carbCaloriesIntake =
            parseFloat(carbCaloriesIntake);
          carbsCaloBgRef.current.style.backgroundSize =
            carbCaloriesIntake + "%";
          setCarbCaloriesIntake((carbCaloriesIntake -= 1));
        }
      
  }
  const maxCarbsCaloricPercentage=()=>{
    
        carbCaloriesIntake = parseFloat(carbCaloriesIntake);
        carbsCaloBgRef.current.style.backgroundSize =
          carbCaloriesIntake + "%";
        setCarbCaloriesIntake((carbCaloriesIntake += 1));
      
  }

  const handelProteinCalorisePerdayChange=(e)=>{
    setProteinCaloriesPerDay(e.target.value);
    pieChartdata.splice(0, 1, parseInt(e.target.value));
    setPieChartData(pieChartdata);
  }
  const handelFatgramPerday=(e)=>{
   
        setFatTDEE(e.target.value);
        setFatCalories(9 * e.target.value);
      
  }
  const handelFatCaoriesPerday=(e)=>{
        setFatCalories(e.target.value);
        pieChartdata.splice(1, 1, parseInt(e.target.value));
        setPieChartData(pieChartdata);
      
  }
  const handelProteingramPerday=(e)=>{
   
        setProtienPerDay(e.target.value);
        setProteinCaloriesPerDay(4 * e.target.value);
      
      
  }
  return (
    // <div className="c-page-wrapper c-page-wrapper-mealplan">
    <div className="">
      {loading ? (
        <div>
          <div className="" style={{display:"flex",justifyContent:"center"}}>
          {/* <Loading /> */}
          <img className="loader" src={aurumLogo} />
        </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          {showCalculator ? (
            <>
              <h2 style={{ fontWeight: "bold" }}>
                {selectedClient.first_name + " " + selectedClient.last_name}
              </h2>
              <div
                className="calorie-count"
                style={{ background: "#dde0e8", marginTop: "unset" }}
              >
                <div
                  className="calorie-settings-tdde"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    // style={{
                    //   marginRight: "7px",
                    //   display: "flex",

                    //   flexDirection: "column",
                    // }}
                    className="gender"
                  >
                    <span style={{ fontWeight: "bolder" }}>Gender*</span>
                    <DropDown
                      className="Dropdown-root-gender"
                      options={genderDrop}
                      value={chooseGender}
                      onChange={(e) => {
                        setChooseGender(e);
                      }}
                    />
                  </div>
                  <div
                    className="calorie-activity"
                    style={{ marginTop: "unset" }}
                  >
                    <p style={{ fontWeight: "bolder" }}> Activity*</p>
                    <DropDown
                      options={activityFactorsText}
                      value={choosedFactor}
                      onChange={handleChoosedFactor}
                    />
                  </div>
                </div>
                <div
                  className="calorie-settings-tdde"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <div style={{ marginRight: "7px", width: "185px" }}>
                    <Input
                      type="text"
                      placeholder="Enter Weight"
                      name="weight"
                      value={weight}
                      onChange={(e) => {
                        // console.log("weight value", e);
                        setWeight(e);
                      }}
                      label="Weight*"
                     
                    />
                  </div>
                  <div
                    style={{
                      marginLeft: "9px",
                      marginRight: "7px",
                      width: "185px",
                    }}
                  >
                    <Input
                      type="text"
                      placeholder="Enter height"
                      name="height"
                      value={height}
                      label="Height (cm)*"
                      readOnly={true}
                    />
                  </div>
                  <div style={{ marginRight: "7px", width: "185px" }}>
                    <Input
                      type="text"
                      placeholder="Enter weight "
                      name="age"
                      value={age}
                      label="Age*"
                      readOnly={true}
                      
                    />
                  </div>
                  <div style={{ marginRight: "7px", width: "185px" }}>
                    <Input
                      type="text"
                      label="Enter Bodyfat %"
                      value={fat ? fat : ""}
                      onChange={(e) => {
                        setFat(e);
                      }}
                      placeholder="Bodyfat %"
                      error={
                        error && error.type === "location"
                          ? error.message
                          : false
                      }
                      errorStyles={{ width: "150px" }}
                    />
                  </div>
                  <div style={{ marginRight: "7px", width: "185px" }}>
                    <Input
                      type="text"
                      placeholder="lean body mass"
                      name="leannBody"
                      value={leanBodyMass}
                      label="Lean body Mass*"
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              <h2 style={{ fontWeight: "bold", marginTop: "15px" }}>
                Calorie target
              </h2>
              <div
                className="calorie-count"
                style={{ background: "#dde0e8", marginTop: "unset" }}
              >
                <div
                  // className="calorie-settings-tdde"
                  className="calorie-target"
                  // style={{
                  //   display:"flex",
                  //   justifyContent: "space-between",
                  //   alignItems: "center",
                  // }}
                >
                  <div className="c-cal-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      {/* Calories: {parseInt(calInfoSlider)} */}
                      Total Daily Energy Expenditure
                      <br />
                      <div className="range-btn">
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={decrementEnergyExpandHandel}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0}
                          max={10000}
                          value={calInfoSlider}
                          style={{
                            width: "220px",
                          }}
                          ref={calInfoSliderBackRef}
                          onChange={handleChangeCalSlider}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={incrementEnergyExpandHandel}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      <Rating rating={calInfoSlider} maxRating={10000} />
                    </div>
                    <div>
                      <input
                        className="c-slider-input"
                        // placeholder={"Calories  ( per day)"}
                        type="number"
                        max={10000}
                        min={0}
                        placeholder="... kcal"
                        value={
                          calInfoSlider
                            ? parseFloat(calInfoSlider).toFixed(2)
                            : ""
                        }
                        onChange={(e) => {
                          setKcal(e.target.value);
                          handleChangeCalSlider(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="c-cal-wraper-goal">
                    <div className="goal-drop-down">
                      {/* //dropdown */}
                      <label
                        className="c-input-label"
                        style={{ marginBottom: "unset" }}
                      >
                        Goal
                      </label>
                      {/* <DropDown
                        options={goal}
                        value={choosedGoal}
                        onChange={(e) => setChoosedGoal(e)}
                      /> */}
                      {/* {console.log("selected goal", selectedGoal,filter_out_goal_idx,goalValue)} */}
                      <Select
                        className="calorie-tooltip-desc"
                        options={customGoalToolTip}
                        onChange={handelCalorieTarget}
                      />
                      {/* <select>
                        <option value="-750">Agressive deficit (-750kcal)</option>
                        <option value="-750">Agressive deficit (-750kcal)</option>
                        <option value="-750">Agressive deficit (-750kcal)</option>
                       
                      </select> */}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        className="c-input-label"
                        style={{ marginBottom: "unset" }}
                      >
                        Calorie Target
                      </label>
                      <input
                        className="c-input-macro-calc font-w-6"
                        type="text"
                        placeholder={"... kcal"}
                        // type="number"
                        value={calorieTarget ? calorieTarget : ""}
                        onChange={(e) => setCalorieTarget(e.target.value)}
                      />
                      {/* <Input
                      type="text"
                      placeholder="lean body mass"
                      name="calories"
                      value={parseInt(calInfoSlider)}
                      label="Calories (Kcal)*"
                    /> */}
                    </div>
                  </div>
                </div>
              </div>
              <h2 style={{ fontWeight: "bold", marginTop: "15px" }}>
                Macronutrient Targets
              </h2>

              <div
                className="calorie-count"
                style={{ background: "#dde0e8", marginTop: "unset" }}
              >
                <h4 style={{ fontWeight: "bolder", fontSize: "20px" }}>
                  Protein
                </h4>
                <div className="calorie-settings-tdde slider-wraper-div">
                  <div className="slider-with-input-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      Protein (g/kg Bodyweight){" "}
                      {/* {parseFloat(proteinSlider).toFixed(2)} */}
                      <br />
                      <div className="range-btn">
                        <button
                          type="button"
                          style={{ cursor: "pointer" }}
                          onClick={minProteinBodyWeightBtn}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0.0}
                          max={10.0}
                          step={0.1}
                          value={proteinSlider}
                          ref={proteinSliderBgRef}
                          style={{
                            width: "220px",
                          }}
                          onChange={handleChangeProtienSlider}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={maxProteinBodyWeight}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      <Rating rating={proteinSlider} maxRating={5} />
                    </div>
                    <div>
                      <input
                        className="c-slider-input font-w-6"
                        placeholder="0.1-10.0g"
                        type="number"
                        min={0.0}
                        max={10.0}
                        step={0.1}
                        value={proteinSlider ? proteinSlider.toFixed(2) : ""}
                        onChange={(e) => {
                          setProteinBodyweightSliderInput(e.target.value);
                          handleChangeProtienSlider(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="c-input-wrapper-with-label">
                    <label className="c-input-label">
                      Protein (gram per day)
                    </label>
                    <input
                      className="c-input-macro-calc"
                      type="number"
                      value={parseInt(protienPerDay)}
                      onChange={handelProteingramPerday}
                    />
                  </div>
                </div>
                <div className="calorie-settings-tdde slider-wraper-div">
                  <div className="slider-with-input-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      Protein (g/kg Lean Body Mass) <br />
                      <div className="range-btn">
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={minLeanBodymassRange}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0.0}
                          max={10.0}
                          step={0.1}
                          value={proteinLeanMass}
                          ref={proteinLeanMassBgBgRef}
                          style={{
                            width: "220px",
                          }}
                          onChange={handleProteinLeanMass}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={maxLeanBodymassRange}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      <Rating rating={proteinLeanMass} maxRating={5} />
                    </div>
                    <input
                      className="c-slider-input font-w-6"
                      placeholder="0.1-10.0g"
                      type="number"
                      min={0.0}
                      max={10.0}
                      step={0.1}
                      value={proteinLeanMass ? proteinLeanMass.toFixed(2) : ""}
                      onChange={handleProteinLeanMass}
                    />
                  </div>
                  <div className="c-input-wrapper-with-label">
                    <label className="c-input-label">
                      Protein (calories per day)
                    </label>
                    <input
                      className="c-input-macro-calc"
                      placeholder={"Calories  ( per day)"}
                      type="number"
                      value={parseInt(proteinCaloriesPerDay)}
                      onChange={handelProteinCalorisePerdayChange}
                    />
                  </div>
                </div>

                <div className="calorie-settings-tdde slider-wraper-div">
                  <div className="slider-with-input-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      Protein (% of Caloric Intake){" "}
                      {/* {parseFloat(proteinSlider).toFixed(2)} */}
                      <br />
                      <div className="range-btn">
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={minCaloricIntakePercentage}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={1}
                          value={calorieTarget > 0 ? protienCaloriesIntake : 0}
                          style={{
                            width: "220px",
                          }}
                          ref={proteinCaloriesBgRef}
                          onChange={handelProteinClaoriesIntake}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={maxCaloricIntakePercentage}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      <Rating rating={protienCaloriesIntake} maxRating={100} />
                    </div>
                    <div>
                      <input
                        className="c-slider-input font-w-6"
                        placeholder="0-100%"
                        type="text"
                        // min={0}
                        // max={100}
                        // step={1}
                        value={
                          protienCaloriesIntake ? protienCaloriesIntake : ""
                        }
                        onChange={handelProteinClaoriesIntake}
                        // onChange={(e)=>{setProtienCaloriesIntake(e.target.value)}}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="calorie-count" style={{ background: "#dde0e8" }}>
                <div className="calorie-calculator">
                  {/* Fat Section */}
                  <h4 style={{ fontWeight: "bolder", fontSize: "20px" }}>
                    Fat
                  </h4>
                  <div
                  // className="calorie-settings-tdde"
                  // style={{
                  //   justifyContent: "space-between",
                  //   alignItems: "center",
                  //   // width:"73%"
                  // }}
                  >
                    <div className="calorie-settings-tdde slider-wraper-div">
                      <div className="slider-with-input-wraper">
                        <div style={{ fontWeight: "bold" }}>
                          Fat (g/kg Bodyweight)
                          <br />
                          <div className="range-btn">
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={minFatBodyWeight}
                            >
                              <FaMinusCircle size={20} />
                            </button>
                            <input
                              type="range"
                              min={0.0}
                              max={5.0}
                              step={0.1}
                              value={fatSlider}
                              style={{
                                width: "220px",
                              }}
                              ref={fatBgRef}
                              onChange={handleFatSlider}
                            />
                            <button
                              // style={{ cursor: "pointer" }}
                              className="plus-btn"
                              onClick={maxFatBodyWeight}
                            >
                              <IoMdAddCircle size={23} />
                            </button>
                          </div>
                          <br />
                          <Rating rating={fatSlider} maxRating={5.0} />
                        </div>
                        <div>
                          <input
                            className="c-slider-input font-w-6"
                            placeholder="0.1-5.0g"
                            type="number"
                            min={0.0}
                            max={5.0}
                            step={0.1}
                            value={fatSlider ? fatSlider.toFixed(2) : ""}
                            onChange={handleFatSlider}
                          />
                        </div>
                      </div>

                      <div className="c-input-wrapper-with-label">
                        <label className="c-input-label">
                          Fat (gram per day)
                        </label>
                        <input
                          className="c-input-macro-calc"
                          value={parseInt(fatTDEE)}
                          onChange={handelFatgramPerday}
                          type="number"
                        />
                      </div>
                    </div>

                    <div className="calorie-settings-tdde slider-wraper-div">
                      <div className="slider-with-input-wraper">
                        <div style={{ fontWeight: "bold" }}>
                          Fat (% of Caloric Intake){" "}
                          {/* {parseFloat(proteinSlider).toFixed(2)} */}
                          <br />
                          <div className="range-btn">
                            <button
                              style={{ cursor: "pointer" }}
                              onClick={minFatCaloricPercentage}
                            >
                              <FaMinusCircle size={20} />
                            </button>
                            <input
                              type="range"
                              min={0}
                              max={100}
                              step={1}
                              ref={fatCaloriesBgRef}
                              value={calorieTarget > 0 ? fatCaloriesIntake : 0}
                              style={{
                                width: "220px",
                              }}
                              onChange={handelFatCaloriesIntake}
                            />
                            <button
                              // style={{ cursor: "pointer" }}
                              className="plus-btn"
                              onClick={maxFatCaloricPercentage}
                            >
                              <IoMdAddCircle size={23} />
                            </button>
                          </div>
                          <br />
                          <Rating rating={fatCaloriesIntake} maxRating={5} />
                        </div>
                        <div>
                          <input
                            className="c-slider-input font-w-6"
                            placeholder="0-100%"
                            type="number"
                            max={100}
                            min={0}
                            step={1}
                            value={fatCaloriesIntake ? fatCaloriesIntake : ""}
                            onChange={handelFatCaloriesIntake}
                          />
                        </div>
                      </div>
                      <div className="c-input-wrapper-with-label">
                        <label className="c-input-label">
                          Fat (calories per day)
                        </label>
                        <input
                          className="c-input-macro-calc"
                          value={parseInt(fatCalories)}
                          type="number"
                          onChange={handelFatCaoriesPerday}
                        />
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>

              <div
                className="calorie-count"
                style={{ background: "#dde0e8", marginTop: "15px" }}
              >
                {/* Carbohydrate section clone one */}
                <h4 style={{ fontWeight: "bold", fontSize: "20px" }}>
                  Carbohydrates
                </h4>
                <div className="calorie-settings-tdde slider-wraper-div">
                  <div className="slider-with-input-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      Carbs (g/kg Bodyweight){" "}
                      {/* {parseFloat(proteinSlider).toFixed(2)} */}
                      <br />
                      <div className="range-btn">
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={minCarbsBodyWeight}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0.1}
                          max={15.0}
                          step={0.1}
                          value={carbsWeight}
                          style={{
                            width: "220px",
                          }}
                          ref={carbsBgRef}
                          onChange={handelCarbsWeight}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={maxCarbsBodyWeight}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      {/* <Rating  rating={proteinSlider} maxRating={15} /> */}
                    </div>
                    <div>
                      <input
                        className="c-slider-input font-w-6"
                        // placeholder={"Calories  ( per day)"}
                        type="number"
                        min={0.1}
                        max={15.0}
                        step={0.1}
                        placeholder="0.1 -15.0g"
                        // value={proteinSlider==0?"0.1-5.0g":proteinSlider}
                        value={carbsWeight ? carbsWeight.toFixed(2) : ""}
                        onChange={handelCarbsWeight}
                      />
                    </div>
                  </div>
                  <div className="c-input-wrapper-with-label">
                    <label className="c-input-label">
                      Carbs (gram per day)
                    </label>
                    <input
                      className="c-input-macro-calc"
                      // placeholder={"Calories  ( per day)"}
                      type="number"
                      // value={parseInt(proteinCaloriesPerDay)}
                      value={
                        parseInt(carbohaydratePerDay)
                        // Number.isInteger(carbohaydratePerDay)
                        //   ?
                        //   : parseInt(carbohaydratePerDay)
                      }
                      onChange={(e) => setCarboHyderatePerDay(e.target.value)}
                      // onChange={(e) => setProteinCaloriesPerDay(e.target.value)}
                    />
                  </div>
                </div>

                <div className="calorie-settings-tdde slider-wraper-div">
                  <div className="slider-with-input-wraper">
                    <div style={{ fontWeight: "bold" }}>
                      Carbs (% of Caloric Intake) <br />
                      <div className="range-btn">
                        <button
                          style={{ cursor: "pointer" }}
                          onClick={minCarbsCaloricPercentage}
                        >
                          <FaMinusCircle size={20} />
                        </button>
                        <input
                          type="range"
                          min={0}
                          max={100}
                          step={1}
                          value={calorieTarget ? carbCaloriesIntake : 0}
                          ref={carbsCaloBgRef}
                          style={{
                            width: "220px",
                          }}
                          onChange={handleCarbsCalories}
                        />
                        <button
                          // style={{ cursor: "pointer" }}
                          className="plus-btn"
                          onClick={maxCarbsCaloricPercentage}
                        >
                          <IoMdAddCircle size={23} />
                        </button>
                      </div>
                      <br />
                      <Rating rating={carbCaloriesIntake} maxRating={100} />
                    </div>
                    <input
                      className="c-slider-input font-w-6"
                      type="number"
                      min={0}
                      max={100}
                      step={1}
                      placeholder="0-100%"
                      value={calorieTarget > 0 ? carbCaloriesIntake : ""}
                      onChange={handleCarbsCalories}
                    />
                  </div>
                  <div className="c-input-wrapper-with-label">
                    <label className="c-input-label">
                      Carbs (calories per day)
                    </label>
                    <input
                      className="c-input-macro-calc"
                      // placeholder={"Calories  ( per day)"}
                      type="number"
                      // value={parseInt(proteinCaloriesPerDay)}
                      // onChange={(e) => setProteinCaloriesPerDay(e.target.value)}
                      value={
                        Number.isInteger(carbohaydratePercentCal)
                          ? carbohaydratePercentCal
                          : parseInt(carbohaydratePercentCal)
                      }
                      onChange={(e) =>
                        setCarboHyderatePercentCal(e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div
                className="calorie-count"
                style={{ background: "#dde0e8", marginTop: "15px" }}
              >
                <h4 style={{ fontWeight: "bold", fontSize: "20px" }}>Totals</h4>
                <div className="total-main">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="total-input-wrapper">
                      <label className="c-input-label">Calories</label>
                      <input
                        className="c-total-input font-w-6 "
                        type="text"
                        value={calorieSummary + " " + "Kcal"}
                        readOnly
                      />
                    </div>
                    <div className="total-input-wrapper">
                      <label className="c-input-label">Protein</label>
                      <input
                        className="c-total-input font-w-6"
                        type="text"
                        value={parseInt(protienPerDay) + " " + "g"}
                      readOnly
                      />
                    </div>
                    <div className="total-input-wrapper">
                      <label className="c-input-label">Fats</label>
                      <input
                        className="c-total-input font-w-6"
                        type="text"
                        value={parseInt(fatTDEE) + " " + "g"}
                        readOnly
                      />
                    </div>
                    <div className="total-input-wrapper">
                      <label className="c-input-label">Carbohydrates</label>
                      <input
                        className="c-total-input font-w-6"
                        type="text"
                        value={parseInt(carbohaydratePerDay) + " " + "g"}
                        readOnly
                      />
                    </div>
                  </div>

                  <div style={{ marginTop: "31px" }}>
                    <Pie data={data} />
                  </div>
                </div>
              </div>

              <div
                className="c-button-collection c-button-collection-largePopup"
                style={{ marginTop: "15px" }}
              >
                <button
                  style={{
                    color: "rgb(255, 255, 255)",
                    backgroundColor: "rgb(0, 189, 165)",
                    width: "150px",
                    height: "41px",
                    borderRadius: "8px",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  onClick={addCalulation}
                >
                  Save
                </button>
                {/* <button className="c-cancel-btn" onClick={() => onCancel()}>
            Cancel
          </button> */}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
}
